import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ApiResponse } from '../models/apiresponse';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CustomerAcknowledgementService {
  constructor(protected httpClient: HttpClient) { }

  private getRequestHeader(isGetApi: boolean) {
    return isGetApi ? {
      headers: new HttpHeaders({
        "x-api-key": environment.apikey
      })
    } : {
      headers: new HttpHeaders({
        "languageId": "1",
        "channel": "ssp",
        "Content-Type": "application/json",
        "x-api-key": environment.apikey
      })
    }
  }

  getOrderDetails(orderid: string): Observable<ApiResponse> {
    return this.httpClient
      .get<ApiResponse>(environment.apiurl + `?caid=${orderid}&summary=YES`,
        this.getRequestHeader(false))
      .pipe(
        map((response: ApiResponse) => {
          return response;
        }),
        catchError((error: HttpErrorResponse) => {
          console.log(error.message);
          throw new Error(error?.statusText);
        })
      );
  }

  getTnCbyProductCategory(languageId: number, category: string): Observable<ApiResponse> {

    let headers = {
      "x-api-key": environment.legalapikey,
      "channel": "ssp"
    };

    return this.httpClient
      .get<ApiResponse>(environment.legalcodumenturl + `/tnc?languageId=${languageId}&category=${category}`, {
        headers })
      .pipe(
        map((response: ApiResponse) => {
          return response;
        }),
        catchError((error) => {
          console.log(error.message);
          throw new Error(error?.statusText);
        })
      );
  }

  submitConsent(orderId: string) {
    return this.httpClient
      .post<ApiResponse>(environment.apiurl,
        {
          "orderid": orderId
        },
        this.getRequestHeader(false))
      .pipe(
        map((response: ApiResponse) => {
          return response;
        }),
        catchError((error) => {
          console.log(error.message);
          throw new Error(error?.statusText);
        })
      );
  }

  verifyPassword(orderid: string,value: number): Observable<ApiResponse> {
    return this.httpClient
      .post<ApiResponse>(environment.apiurl  + `/verify`,
        {
          "orderid": orderid,
          "idvalue": value
        },
        this.getRequestHeader(false))
      .pipe(
        map((response: ApiResponse) => {
          return response;
        }),
        catchError((error) => {
          console.log(error);
          throw new Error(error);
        })
      );
  }

  checkStatus(caid: string): Observable<ApiResponse> {
    return this.httpClient
      .get<ApiResponse>(environment.apiurl + `?caid=${caid}`, 
        this.getRequestHeader(false))
      .pipe(
        map((response: ApiResponse) => {
          return response;
        }),
        catchError((error) => {
          console.log(error.message);
          throw new Error(error?.statusText);
        })
      );
  }

    getChannelCode(caId: string): Observable<ApiResponse> {

    return this.httpClient
      .get<ApiResponse>(environment.apiurl + `/channel?orderId=${caId}`, this.getRequestHeader(false))
      .pipe(
        map((response: ApiResponse) => {
          return response;
        }),
        catchError((error) => {
          console.log(error.message);
          throw new Error(error?.statusText);
        })
      );
  }

  // To check Rid Expiry
  // checkRidExpiry(rid: string): Observable<ApiResponse> {
  //   return this.httpClient
  //     .get<ApiResponse>(environment.tempurl + `/expiry/${rid}`, 
  //       this.getRequestHeader(true))
  //     .pipe(
  //       map((response: ApiResponse) => {
  //         return response;
  //       }),
  //       catchError((error) => {
  //         console.log(error.message);
  //         throw new Error(error?.statusText);
  //       })
  //     );
  // }

}